import { render } from "./NkDot.vue?vue&type=template&id=17132264"
import script from "./NkDot.vue?vue&type=script&lang=js"
export * from "./NkDot.vue?vue&type=script&lang=js"
script.render = render

export default script